import { render, staticRenderFns } from "./WebSite.vue?vue&type=template&id=7c6d2212"
import script from "./WebSite.vue?vue&type=script&lang=ts"
export * from "./WebSite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports